module Client.Admin.DisableUser.Disable

open Shared
open Client
open System
open Elmish
open Illy.SafeStack
open Illy.SafeStack.Client
open Shared.Admin.DisableUser

type Model = 
    {
        CurrentUserId: UserId
        UserId: UserId 
        Reason: Text.Model 
        GeneralError: string option
        Saving: bool
    }

let toDTO (m: Model) = 
    {
        UserId = UserId.unwrap m.UserId
        Reason = Text.toString m.Reason
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Shared.Admin.DisableUser.Validations

    let resetValidations (m: Model) = 
        {m with 
            Reason = Text.resetValidations m.Reason
            GeneralError = None
        }

    let dispatchValidations model = 
        let model = resetValidations model 
        function 
        | ValidationResult.Passed -> model 
        | ValidationResult.Warned _ -> failwith "Did not expect warnings"
        | ValidationResult.Failed (err, _) ->
            let errors = 
                err 
                |> ValidationInfrastructure.bundleValidations 
                    (fun x -> 
                        (match x with 
                        | ReasonValidations _ -> 0 
                        | CannotDisableOwnUser -> 1), DisableValidations.toString x)
                    2
            {model with 
                Reason = Text.setValidations model.Reason errors.[0] None
                GeneralError = errors.[1]
            }

type Msg = 
    | ApiError of ApiError
    | SaveResult of FailureReason option
    | ReasonMsg of Text.Msg
    | CloseOverlay  
    | SaveClicked 


type Event = 
    | CloseOverlay 
    | ApiError of ApiError 
    | SaveSuccessful of notification: string 

module Initialisations = 
    let initReason value =
        Text.CustomSettings.defaultOptions()
        |> Text.init "Reason" "What is the reason for disabling this user?" (Some "Enter Reason") 500. true value

let init userId =
    let u : ClientSideUser = Storage.get Storage.USER_STORAGE_KEY
    {
        CurrentUserId = UserId u.Id
        UserId = userId 
        Reason = Initialisations.initReason None
        GeneralError = None
        Saving = false
    }, []

let update msg model = 
    match msg with 
    | ReasonMsg cMsg ->
        let m, c = Text.update cMsg model.Reason
        {model with Reason = m}, Cmd.map ReasonMsg c |> SideEffect.Cmd
    | Msg.ApiError err -> { model with Saving = false }, err |> ApiError |> SideEffect.Event 
    | Msg.CloseOverlay -> model, CloseOverlay |> SideEffect.Event 
    | SaveClicked -> 
        let dto = toDTO model 
        let vResult = Validations.validateDTO model.CurrentUserId dto
        if Validation.isSuccessful false vResult then 
            {model with Saving = true},
            Api.secureCall<IDisableUserApi,_,_,_> SecuredRoute.Admin (fun api -> api.disable) dto SaveResult Msg.ApiError
            |> SideEffect.Cmd
        else 
            Validations.dispatchValidations model vResult, SideEffect.none
    | SaveResult reason -> 
        match reason with 
        | None
        | Some NothingToDo -> model, "User was disabled successfully." |> Event.SaveSuccessful |> SideEffect.Event
        | Some (FailedValidations v) ->
            Validations.dispatchValidations {model with Saving = false} v, SideEffect.none

let view model dispatch = 
    jQueryUI.modal "Disable User" 50 Msg.CloseOverlay dispatch (Some 800) [
        yield Text.text false model.Reason (ReasonMsg >> dispatch)
        yield UI.renderError model.GeneralError
        yield! UI.saveControls (Some "Disable User") false model.Saving SaveClicked Msg.CloseOverlay dispatch
    ]